import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface RefreshStatelessResponse {
  callSuccess: string;
  errorMessage?: string;
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class CbcStatelessRefreshService {
  constructor(private http: HttpClient) {}

  private buildParams(ssoId: string): HttpParams {
    let p = new HttpParams();
    if (ssoId) p = p.set('sso_id', ssoId);
    return p;
  }

  refreshStatelessData(
    baseUrl: string,
    ssoId: string
  ): Observable<RefreshStatelessResponse> {
    const url = `${baseUrl}/saveJsonObject?action_id=32597`;
    const body = this.buildParams(ssoId).toString();
    return this.http.post<RefreshStatelessResponse>(url, body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      withCredentials: true,
    });
  }
}
